export default __webpack_public_path__ + "static/media/complaints-nav.039a359d.svg";